<template>
  <div class="bidLedger">
    <el-container>
      <el-header>
        <el-form ref="form" :model="searchForm" :inline="true">
          <el-row>
            <el-col :span="6">
              <el-form-item label="采购事项" label-width="120px">
                <el-input
                  v-model="searchForm.projectName"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="采购规模" label-width="120px">
                <el-input
                  v-model="searchForm.bidPlanItem"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="采购计划编号" label-width="120px">
                <el-input
                  v-model="searchForm.bidPlanCode"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <div v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label="采购方式" label-width="120px">
                  <el-input
                    v-model="searchForm.bidPurchaseMethod"
                    placeholder="-请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="成交单位" label-width="120px">
                  <el-input
                    v-model="searchForm.bidWinCompany"
                    placeholder="-请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="选拨时间" label-width="120px">
                  <el-date-picker
                    v-model="searchForm.submitTime"
                    type="daterange"
                    range-separator="至"
                    @blur="handleTimestamp"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </div>
            <el-col :span="showAdvanceFilter ? 6 : 6">
              <div class="handlePanel">
                <el-button type="primary" icon @click="handleClick()"
                  >查询</el-button
                >
                <el-button type="info" icon @click="clearSearchConditions"
                  >重置</el-button
                >
                <el-button type="text" @click="moreScreen">{{
                  showAdvanceFilter ? "收起" : "高级筛选"
                }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <el-col :span="24" style="padding: 0 20px">
          <div class="operatePanel">
            <el-button
              type="primary"
              v-if="btnAuthorize.addBtn.btnEnable"
              icon="el-icon-plus"
              @click="addBidLedger()"
              >新建</el-button
            >
            <el-button
              title="导出"
              type="primary"
              v-if="btnAuthorize.export.btnEnable"
              icon="el-icon-download"
              @click="exportDataList()"
              >导出</el-button
            >
          </div>
        </el-col>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          size="mini"
          style="width: 100%"
          height="100%"
          :span-method="spanMethod"
        >
          <el-table-column type="selection" width="54"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            :prop="item.class"
            :label="item.labelName"
            :sortable="item.sortEnable"
            show-overflow-tooltip
          >
            <template slot-scope="scope" >
              <span v-if="item.contractType">{{
                scope.row[scope.column.property] === "TEMPORARY" ? "是" : "否"
              }}</span>
              <span v-else>{{ scope.row[scope.column.property] }}</span>
            </template>
          </el-table-column>
           <el-table-column
            v-for="(item, index) in tableColumns1"
            :key="index+20"
            :prop="item.class"
            :label="item.labelName"
            :width='item.width'
            min-width="110px"

          >
            <template slot-scope="scope" >
              <el-table
                :data="scope.row.companyList"
                :show-header="false"                     
              >
                <el-table-column
                  prop="companyName"
                  label="响应/报价单位名单"
                  show-overflow-tooltip
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="offerPrice"
                  show-overflow-tooltip
                  label="报价"
                  width="80"
                ></el-table-column>
                <el-table-column
                  prop="bidRemark"
                  label="选拨情况说明"
                  class='no-right-border'
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            header-align="center"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="editBidLedger(scope.row)"
                v-if="btnAuthorize.modifyBtn.btnEnable"
                >修改</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="delBidLedger(scope.row)"
                v-if="btnAuthorize.delBtn.btnEnable"
                >删除</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="bidLedgerDetail(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import {
  getBidLedger, //获取采购计划列表接口
  exportBidLedgerApi, //导出接口
  getOnePlanItems,
  deleteBidLedger,
} from "@/services/bidServices";
import { exportExcelService2 } from "@/services/commonService"
import {
  getsubDeptService, //获取项目部二级项目级联列表
} from "@/services/sysSettingService";
export default {
  name: "bidLedgerMsg",
  props: {
    menuCode: {
      type: String,
    },
  },
  data() {
    return {
      deptIdList: [],
      searchForm: {
        //查询条件form
        bidPlanCode: "", //采购计划编号
        projectName: "", //项目名称
        operateUserId: "", //提报人
        projectDeptId: null, //提报部门
        submitTime: "", //提报时间
        bidStartTimeStart: "", //提报时间起
        bidStartTimeEnd: "", //提报时间止
      },
      tableColumns: [
        { class: "bidPlanCode", labelName: "采购计划编号", sortEnable: false },
        { class: "projectName", labelName: "采购事项", sortEnable: false },
        { class: "bidPlatform", labelName: "采购平台", sortEnable: false },
        { class: "projectScale", labelName: "项目规模", sortEnable: false },
        {
          class: "bidPurchaseMethod",
          labelName: "采购方式",
          sortEnable: false,
        },
        {
          class: "estimatePrice",
          labelName: "预算控制价（万元）",
          sortEnable: false,
        },
        // { class: "bidPlatform", labelName: "采购平台", sortEnable: false },
        {
          class: "bidCompanyCount",
          labelName: "采购/报价单位（个）",
          sortEnable: false,
        },
        { class: "bidStartTime", labelName: "选拨时间", sortEnable: false },
        { class: "bidWinCompany", labelName: "成交单位", sortEnable: false },
        { class: "bidWinPrice", labelName: "成交结果", sortEnable: false },
        {
          class: "bidWinPrice",
          labelName: "成交金额（万元）",
          sortEnable: false,
        },
        // {
        //   class: "company",
        //   labelName: "响应/报价单位",
        //   sortEnable: false,
        // },
        // {
        //   class: "companyName",
        //   labelName: "响应/报价单位名单",
        //   sortEnable: false,
        // },
        // {
        //   class: "offerPrice",
        //   labelName: "报价（万元）",
        //   sortEnable: false,
        // },
        // {
        //   class: "bidRemark",
        //   labelName: "选拨情况说明",
        //   sortEnable: false,
        // },
      ],
      tableColumns1: [
        {
          class: "companyName",
          labelName: "响应/报价单位名称",
          width:110,
          sortEnable: false,
        },
        {
          class: "offerPrice",
          labelName: "报价（万元）",
          width:80,
          sortEnable: false,
        },
        {
          class: "bidRemark",
          labelName: "选拨情况说明",
          sortEnable: false,
        },
      ],
      showAdvanceFilter: false,
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      tableData: [],
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        import: { key: "import", btnEnable: false }, //导入
        export: { key: "export", btnEnable: false },
      },
      gridData: [],
    };
  },
  mounted() {
    this.getDept();
  },
  methods: {
    handleTimestamp() {
      this.$forceUpdate();
    },
    onActive(menuCode) {
      // this.searchForm.id = this.tabRouteParam?.id ?? "";
      this.currentPage = 1;
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.initList(); //获取下拉列表  gaa 20200806
    },
    //点击查询
    handleClick() {
      this.currentPage = 1;
      this.initList();
    },
    //审批关闭
    handleClose(done) {
      this.$confirm("确认关闭审批弹窗吗?", "提示", {
        confirmButtonText: "确认",
      })
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    getDept() {
      let param = {};
      param.deptId = 101;
      getsubDeptService(param).then((res) => {
        if (res.code == 10000000) {
          this.deptIdList = res.data;
        }
      });
    },
    //获取采购计划列表
    initList() {
      let param = {
        // currentUserId: this.currentUserId, // sessionStorage.getItem("userCode"),
        // sort: "name",
        // order: "asc",
        tabIndex: 0,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
      };
      for (let key in this.searchForm) {
        if (this.searchForm[key] !== "") {
          param[key] = this.searchForm[key];
        }
      }
      if (this.searchForm.submitTime && this.searchForm.submitTime.length > 1) {
        param.bidStartTimeStart = this.searchForm.submitTime[0];
        param.bidStartTimeEnd = this.searchForm.submitTime[1];
        delete param.submitTime;
      }
      getBidLedger(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.dealTableData(res);
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    //获取采购计划列表
    getOnePlanItem(row) {
      let param = {
        tabIndex: 0,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        bidLedgerId: row.id,
      };
      getOnePlanItems(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.gridData = res.data;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    dealTableData(res) {
      this.tableData = res.data;
      this.tableHeight = this.$refs.main.$el.offsetHeight - 10;
      this.totalCount = res.total;
    }, //

    onSearch() {
      this.currentPage = 1;
      this.initList();
    },
    //重置查询条件
    clearSearchConditions() {
      for (let key in this.searchForm) {
        if (key != "tabIndex") {
          this.searchForm[key] = "";
        }
      }
    }, //
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initList();
    }, //
    handleCurrentChange(page) {
      this.currentPage = page;
      this.initList();
    },
    //双击跳转采购计划详情
    bidLedgerDetail(row, column, cell, event) {
      let param = {};
      param.id = row.id;
      param.routeId = "bidLedgerDetail";
      this.bus.$emit("navMenuChange", {
        routeId: "bidLedgerDetail",
        routeParam: param,
      });
    },

    //跳转到创建界面
    addBidLedger() {
      let memberData = {};
      // memberData.path = "order-list";
      this.bus.$emit("navMenuChange", {
        routeId: "bidLedgerAdd",
        routeParam: memberData,
      });
    },
    //跳转到修改界面
    editBidLedger(row) {
      // if (
      //   row.status == 1 &&
      //   row.status == 4 &&
      //   row.status == 0
      // ) {
      //   this.$alert("只有 撤回/驳回/已保存 状态的合同可以修改", "提示", {
      //     confirmButtonText: "确定",
      //   });
      //   return;
      // }
      let memberData = {};
      memberData.id = row.id; //选中行
      this.bus.$emit("navMenuChange", {
        routeId: "bidLedgerEdit",
        routeParam: memberData,
      });
    },

    //删除
    delBidLedger(row) {
      let param = {
        // currentUserId: 1 //sessionStorage.getItem("userCode"),
      };
      param.bidLedgerId = row.id;
      this.$confirm("确认删除该条数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        deleteBidLedger(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.$alert("删除成功", "提示", {
                confirmButtonText: "确定",
              });
              this.handleClick();
            } else if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
      });
    },
    //导出
    exportDataList() {
      exportBidLedgerApi(this.searchForm)
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
      if (this.showAdvanceFilter) {
        this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
      } else {
        this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
      }
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
    if (column.property === 'bidRemark') { // 假设想要去掉“姓名”列的右边框
      return 'no-right-border';
    }
  },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      const fields = ["companyName"];
      // 当前行的数据
      const cellValue = row["companyName"];
      if (columnIndex >= 12 && columnIndex <= 14) {
        // 当上一行的数据等于当前行数据时，当前行单元格隐藏
        if (columnIndex == 13) {
          return { rowspan: 1, colspan: 3 };
        } else {
          return { rowspan: 1, colspan: 0 };
        }
        // const _row = this.tableData.filter(item=>item.bidPlanCode==row.bidPlanCode).length;
        // const _col = _row > 0 ? 1 : 0;
        // return {
        //   rowspan: _row,
        //   colspan: _col,
        // };
      }
    },
    // spanMethod({ row, column, rowIndex, columnIndex }) {
    //   const fields = ["bidPlanCode"];
    //   // 当前行的数据
    //   const cellValue = row["bidPlanCode"];
    //   if (columnIndex < 13 || columnIndex > 15) {
    //     const prevRow = this.tableData[rowIndex - 1]; //上一行数据
    //     let nextRow = this.tableData[rowIndex + 1]; //下一行数据
    //     // 当上一行的数据等于当前行数据时，当前行单元格隐藏
    //     if (prevRow && prevRow["bidPlanCode"] === cellValue) {
    //       return { rowspan: 0, colspan: 0 };
    //     } else {
    //       // 反之，则循环判断若下一行数据等于当前行数据，则当前行开始进行合并单元格
    //       let countRowspan = 1; //用于合并计数多少单元格
    //       while (nextRow && nextRow["bidPlanCode"] === cellValue) {
    //         nextRow = this.tableData[++countRowspan + rowIndex];
    //       }
    //       if (countRowspan > 1) {
    //         return { rowspan: countRowspan, colspan: 1 };
    //       }
    //     }
    //     // const _row = this.tableData.filter(item=>item.bidPlanCode==row.bidPlanCode).length;
    //     // const _col = _row > 0 ? 1 : 0;
    //     // return {
    //     //   rowspan: _row,
    //     //   colspan: _col,
    //     // };
    //   }
    // },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.el-container {
  padding-top: 0;
  .el-header {
    padding: 0;
    form {
      padding-right: 20px;
    }
  }
}
.bidLedger {
  height: 100%;
  background-color: white;
}
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
.el-select {
  width: 100%;
}
.hide {
  display: none;
}

/deep/.overTimeMark {
  // background-color: #e9f4fa;
  .el-tooltip {
    color: #333333;
  }
}

/deep/.el-form-item__content {
  width: 60%;
}
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-date-editor {
  width: 100% !important;
}

/deep/.no-right-border {
  border-right: none ;
}
</style>
